
/**
 * Traduit les messages d'erreur techniques de Supabase/Stripe en français compréhensible.
 * Évite toute mention technique (Supabase, Database, JWT, etc.)
 */
export const translateError = (error) => {
    if (!error) return "Une erreur inconnue est survenue.";
    
    const message = error.message || error;
    const msgLower = message.toLowerCase();

    // -- AUTHENTIFICATION --
    if (msgLower.includes("invalid login credentials")) {
        return "Email ou mot de passe incorrect.";
    }
    if (msgLower.includes("user already exists") || msgLower.includes("already registered")) {
        return "Un compte existe déjà avec cette adresse email.";
    }
    if (msgLower.includes("email not confirmed")) {
        return "Veuillez confirmer votre adresse email avant de vous connecter.";
    }
    if (msgLower.includes("password is too short")) {
        return "Le mot de passe est trop court (6 caractères minimum).";
    }
    if (msgLower.includes("invalid email")) {
        return "L'adresse email n'est pas valide.";
    }

    // -- BASE DE DONNÉES / RÉSEAU --
    if (msgLower.includes("invalid input syntax for type date")) {
        return "Le format de la date est incorrect.";
    }
    if (msgLower.includes("network error") || msgLower.includes("fetch")) {
        return "Problème de connexion réseau. Veuillez vérifier votre internet.";
    }
    if (msgLower.includes("not found")) {
        return "L'élément demandé n'a pas été trouvé.";
    }
    if (msgLower.includes("rls") || msgLower.includes("permission") || msgLower.includes("policy") || msgLower.includes("violation")) {
        return "Action non autorisée ou impossible pour le moment.";
    }
    if (msgLower.includes("server") || msgLower.includes("database") || msgLower.includes("cache")) {
        return "Une erreur serveur est survenue. Veuillez réessayer plus tard.";
    }

    // -- PAIEMENTS / STRIPE --
    if (msgLower.includes("payment failed")) {
        return "Le paiement a échoué. Veuillez réessayer.";
    }
    if (msgLower.includes("insufficient credits")) {
        return "Vous n'avez pas assez de crédits pour cette action.";
    }

    // -- PAR DÉFAUT --
    return "Une erreur est survenue lors de l'opération. Veuillez réessayer.";
};
